module.exports = __webpack_public_path__ + "img/2301001lghhb.d5dfa0b2.png";